export enum StorageKey {
	TOKEN = "token",
	REFRESH_TOKEN = "refreshToken",

	LAST_ORDER = "lastOrder",
	ACTUAL_ORDER_ITEM_BEFORE_LOGIN = "actualOrderItemBeforeLogin",

	PRE_USER = "pu"
}